export function getRandom(): string {
  let rnd: number;
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    // Usar el generador seguro de números aleatorios
    rnd = Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] / 4);
  } else {
    // Fallback a Math.random() (menos seguro)
    rnd = Math.round(Math.random() * 10000000);
  }

  const date = +new Date();
  const rv = `${date}${rnd}`;
  return rv;
}
